export const warningSelector = '[data-document-parser-role="warning"]';
export const selectorText = '[data-document-parser-id^="studySection"] table, [data-document-parser-id^="studySection"] p,  [data-document-parser-id^="studySection"] [data-document-parser-role="objectiveGroup"], [data-document-parser-id^="studySection"] ul, [data-document-parser-id^="studySection"] ol, [data-document-parser-id^="studySection"] h1, [data-document-parser-id^="studySection"] h2, [data-document-parser-id^="studySection"] h3, [data-document-parser-id^="studySection"] h4, [data-document-parser-id^="studySection"] h5';
export const selectorAnyDayRule = [
    'activityScheduleRuleCell_custom-non-reported',
    'activityScheduleRuleCell_custom-reported',
    'activityScheduleRuleCell_recurring',
    'activityScheduleRuleCell_non-fixed-day',
];
export const selectorFootNote = '[data-document-parser-role="footnoteAnnotation"]';
export const selectorSoaActivity = 'data-document-parser-role="activityCell"';
export const selectorSoaGrid = 'div[style*="grid-area"]';
export const selectorSoaActivities = '[data-document-parser-role="activityGroupCell"], [data-document-parser-role="activityCell"]';
export const selectorActivityTagsContainer = '[data-document-parser-id="activity-name-auto-calculated-tags-container"]';
export const selectorActivityTags = '[data-document-parser-role="autoTagItem"]';
export const selectorBullet = 'activityScheduleRuleCell';
export const selectorCycleTimepoint = 'data-document-parser-style="bordered"';
export const tableHiddenCell = '[data-document-parser-id="hiddenAreaCell"]';
export const colorSwatch = '[data-document-parser-id="colorSwatch"] button';
export const generalInformationSection = '[data-document-parser-section-id="generalInformation"]';
export const earlyTerminationHeaderCell = 'earlyTerminationHeaderCell';
export const unscheduledVisitHeaderCell = 'unscheduledVisitHeaderCell';
export const epochHeaderCell = 'epochHeaderCell';
export const epochDescription = 'epochDescription';
export const EpochDisplayName = 'EpochDisplayName';
export const classTableWidget = 'table-widget';
export const referenceValueSpinner = '[data-document-parser-id="referenceValueSpinner"]';
export const objectiveReferenceSpinner = '.faro-variable-loading';
export const checkMark = '✓';
export const headers = 'h1, h2, h3, h4, h5';
export const orderedListTypes = ['1', 'a', 'i'];
export const mutationObserveConfig = { childList: true, subtree: true };
export const numberRadix = 10;
export const mutationObserveTimeout = 5000;
export const beforeScrapingTimeout = 1000;
export const headerRowsCountOfSOA = 6;
export const maxDocxColumnCount = 50;
export const exportError = 'An error occurred exporting study. Please try again';
// Widgets definitions
export const widgets = {
    interventionGroups: {
        name: 'Intervention Groups',
        dataDocumentParserId: 'interventionGroupTable',
        isImageOnly: false,
    },
    studyDesignSettings: {
        name: 'Study Design Settings',
        dataDocumentParserId: 'studySettingsTable',
        isImageOnly: false,
        header: '<h3>Settings</h3>',
    },
    studyDesignStages: {
        name: 'Stages',
        dataDocumentParserId: 'adaptiveStages',
        isImageOnly: true,
        header: '<h3>Adaptive Stages</h3>',
    },
    studyDesignSchema: {
        name: 'Schema',
        dataDocumentParserId: 'studyDesignTable',
        variantsSelector: '[data-document-parser-id="schemaPills"] [data-document-parser-role="pill"] > *',
        contentSelector: variantId => variantId != null
            ? `[data-document-parser-id="studyDesignTable"][data-document-parser-variant-id="${variantId}"]`
            : '[data-document-parser-id="studyDesignTable"]',
        isImageOnly: true,
        header: '<h3>Schema</h3>',
    },
    scheduleOfActivities: {
        name: 'Schedule of Activities',
        dataDocumentParserId: 'scheduleOfActivitiesTable',
        variantsSelector: '[data-document-parser-id="soaPills"] input[type="checkbox"]',
        contentSelector: variantId => variantId != null
            ? `[data-document-parser-id="scheduleOfActivitiesTableContainer"][data-document-parser-variant-id="${variantId}"] [data-document-parser-id="scheduleOfActivitiesTable"]`
            : '[data-document-parser-id="scheduleOfActivitiesTable"]',
        isImageOnly: false,
    },
};
export const SOAClasses = [
    {
        selector: `[data-document-parser-role="epochHeaderCell"]>div,
                    [data-document-parser-role="unscheduledVisitHeaderCell"]>div>div,
                    [data-document-parser-role="earlyTerminationHeaderCell"]>div>div`,
        class: ['epochHeaderCell-epochName'],
    },
    {
        selector: `[data-document-parser-id="cycleDisplay"]`,
        class: ['epochHeaderCell-epochDuration'],
    },
    {
        selector: `tr td:last-child, tr td:nth-child(2)`,
        class: ['soa-border-right'],
    },
    {
        selector: `tr td:first-child`,
        class: ['soa-border-left'],
    },
    {
        selector: `tr:last-child td, tr:nth-child(${headerRowsCountOfSOA + 1}) td`,
        class: ['soa-border-bottom'],
    },
    {
        selector: `tr:nth-child(2) td`,
        class: ['soa-border-top'],
    },
    {
        selector: `.schedule-of-activities td:nth-child(2)`,
        class: ['activities-column'],
    },
    {
        selector: `tr td:first-child`,
        class: ['no-border-right', 'decentralized-column'],
    },
    {
        selector: `tr td:nth-child(2)`,
        class: ['no-border-left'],
    },
    {
        selector: `td+td+td, td+td+td div, td+td+td span`,
        class: ['text-align-center'],
    },
    {
        selector: `tr:nth-child(2) td:first-child, tr:nth-child(2) td:nth-child(2)`,
        class: ['no-border-bottom'],
    },
    {
        selector: `tr:nth-child(3) td:first-child, tr:nth-child(3) td:nth-child(2), 
                    tr:nth-child(4) td:first-child, tr:nth-child(4) td:nth-child(2)`,
        class: ['no-border-bottom', 'no-border-top'],
    },
    {
        selector: `tr:nth-child(5) td:first-child, tr:nth-child(5) td:nth-child(2)`,
        class: ['no-border-top'],
    },
];
//# sourceMappingURL=constants.js.map